import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import KlassiBrand from './KlassiBrand';

const Footer = () => {
  const location = useLocation();
  let tagline = "Empowering progress through innovative technology solutions and personalised childcare services — helping businesses thrive and families flourish with the support, care, and intelligence they deserve.";
  if (location.pathname.startsWith('/klassicare')) {
    tagline = "Delivering exceptional childcare services with a personal touch, built on trust, quality, and thoughtful matching.";
  } else if (location.pathname.startsWith('/klassitech')) {
    tagline = "Empowering businesses with innovative technology solutions that drive efficiency, growth, and digital transformation.";
  }

  return (
    <footer className="bg-dark text-light py-4 w-100">
      <Container>
        <Row className="g-4">
          <Col md={4}>
            <h5 className="text-warning mb-3"><KlassiBrand /></h5>
            <p className="text-light-50">{tagline}</p>
            <p className="text-light-50">
              Innovative solutions. Personalised care. Empowering progress.
            </p>
          </Col>
          <Col md={4}>
            <h5 className="text-warning mb-3">Quick Links</h5>
            <ul className="list-unstyled">
              <li className="mb-2">
                <Link to="/" className="text-light-50 text-decoration-none">Home</Link>
              </li>
              <li className="mb-2">
                <Link to="/about" className="text-light-50 text-decoration-none">About</Link>
              </li>
              <li className="mb-2">
                <Link to="https://ktestgenie.com" className="text-light-50 text-decoration-none">TestGenie</Link>
              </li>
              <li className="mb-2">
                <Link to="/klassitech" className="text-light-50 text-decoration-none">KlassiTech</Link>
              </li>
              {/*<li className="mb-2">*/}
              {/*  <Link to="/klassicare" className="text-light-50 text-decoration-none">KlassiCare</Link>*/}
              {/*</li>*/}
              <li className="mb-2">
                <Link to="/contact" className="text-light-50 text-decoration-none">Contact</Link>
              </li>
            </ul>
          </Col>
          <Col md={4}>
            <h5 className="text-warning mb-3">Contact Us</h5>
            <ul className="list-unstyled text-light-50">
              <li className="mb-2">
                <i className="bi bi-envelope me-2"></i>
                <a href="mailto:info@klassi.co.uk" className="text-primary text-decoration-none">
                  info@klassi.co.uk
                </a>
              </li>
            </ul>
            <div className="social-icons mt-3">
              <a href="https://linkedin.com/in/larryg" target="_blank" rel="noopener noreferrer" className="text-decoration-none me-3">
                <i className="bi bi-linkedin fs-4 text-primary"></i>
              </a>
              <a href="https://twitter.com/LarryG_01" target="_blank" rel="noopener noreferrer" className="text-decoration-none me-3">
                <i className="bi bi-twitter-x fs-4 text-light"></i>
              </a>
              <a href="https://github.com/klassijs" target="_blank" rel="noopener noreferrer" className="text-decoration-none me-3">
                <i className="bi bi-github fs-4 text-light"></i>
              </a>
              <a href="https://youtube.com/@larryg_01" target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                <i className="bi bi-youtube fs-4 text-danger"></i>
              </a>
            </div>
          </Col>
        </Row>
        <hr className="my-4 border-secondary" />
        <div className="text-center text-light-50">
          <p className="mb-0">&copy; 2010 - 2026 <KlassiBrand />. All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer; 